<template>
  <div class="panel pure-form">
    <div class="cabecera">
      Pólizas Afectadas
    </div>

    <div class="texto">
      Selecciona las pólizas en las que quieres que modifiquemos tu {{ campo }}.
    </div>

    <div v-if="polizasVeh.length">
      Autos
      <div v-for="item in polizasVeh" :key="item.idPoliza" class="fila">
        <label for="chkPolVeh" class="pure-checkbox texto">
          <input id="chkPolVeh" v-model="item.checked" :value="item.idPoliza" type="checkbox" />
          {{ item.numPoliza }} - {{ item.marca }} {{ item.modelo }} ({{ item.matricula }})
        </label>
      </div>
    </div>
    <div v-if="polizasHog.length">
      Hogar
      <div v-for="item in polizasHog" :key="item.idPoliza" class="fila">
        <label for="chkPolHog" class="pure-checkbox texto fila">
          <input id="chkPolHog" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.direccion }}
        </label>
      </div>
    </div>
    <div v-if="polizasDecesos.length">
      Decesos
      <div v-for="item in polizasDecesos" :key="item.idPoliza" class="fila">
        <label for="chkPolDecesos" class="pure-checkbox texto fila">
          <input id="chkPolDecesos" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.producto }}
        </label>
      </div>
    </div>
    <div v-if="polizasMovilidad.length">
      Movilidad
      <div v-for="item in polizasMovilidad" :key="item.idPoliza" class="fila">
        <label for="chkPol" class="pure-checkbox texto fila">
          <input id="chkPol" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.marca }} {{ item.modelo }}
        </label>
      </div>
    </div>
    <div v-if="polizasNegocio.length">
      Negocio
      <div v-for="item in polizasNegocio" :key="item.idPoliza" class="fila">
        <label for="chkPol" class="pure-checkbox texto fila">
          <input id="chkPol" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.direccionNeg }}
        </label>
      </div>
    </div>
    <div v-if="polizasAccidentes.length">
      Accidentes
      <div v-for="item in polizasAccidentes" :key="item.idPoliza" class="fila">
        <label for="chkPol" class="pure-checkbox texto fila">
          <input id="chkPol" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.riesgoAseguradoStr }}
        </label>
      </div>
    </div>
    <div v-if="polizasMascotas.length">
      Mascotas
      <div v-for="item in polizasMascotas" :key="item.idPoliza" class="fila">
        <label for="chkPol" class="pure-checkbox texto fila">
          <input id="chkPol" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.riesgoAseguradoStr }}
        </label>
      </div>
    </div>
    <div v-if="polizasSaludMMT.length">
      Salud MMT
      <div v-for="item in polizasSaludMMT" :key="item.idPoliza" class="fila">
        <label for="chkPol" class="pure-checkbox texto fila">
          <input id="chkPol" v-model="item.checked" :value="item.idPoliza" type="checkbox" checked="true" />
          {{ item.numPoliza }} - {{ item.riesgoAseguradoStr }}
        </label>
      </div>
    </div>


    <div v-if="errorSeleccion" class="noValido">{{ errorSeleccion }}</div>

    <button class="pure-button" @click="siguiente()">
      <strong>Cambiar {{ campo }}</strong>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    campo: { type: String, required: true },
  },

  data() {
    return {
      errorSeleccion: "",
      polizasChecked: [],
    };
  },

  computed: {
    polizasVeh() {
      let lstVeh = this.$store.state.portfolio.lstPolizasVeh;
      lstVeh.forEach((element) => {
        element.checked = true;
      });
      return lstVeh;
    },
    polizasHog() {
      let lstHogar = this.$store.state.portfolio.lstPolizasHogar;
      lstHogar.forEach((element) => {
        element.checked = true;
      });
      return lstHogar;
    },
    polizasDecesos() {
      let lstDec = this.$store.state.portfolio.lstPolizasDec;
      lstDec.forEach((element) => {
        element.checked = true;
      });
      return lstDec;
    },
    polizasMovilidad() {
      let lst = this.$store.state.portfolio.lstPolizasMovilidad;
      lst.forEach((element) => {
        element.checked = true;
      });
      return lst;
    },
    polizasNegocio() {
      let lst = this.$store.state.portfolio.lstPolizasNegocio;
      lst.forEach((element) => {
        element.checked = true;
      });
      return lst;
    },
    polizasAccidentes() {
      let lst = this.$store.state.portfolio.lstPolizasAccidentes;
      lst.forEach((element) => {
        element.checked = true;
      });
      return lst;
    },
    polizasMascotas() {
      let lst = this.$store.state.portfolio.lstPolizasMascotas;
      lst.forEach((element) => {
        element.checked = true;
      });
      return lst;
    },
    polizasSaludMMT() {
      let lst = this.$store.state.portfolio.lstPolizasSaludMMT;
      lst.forEach((element) => {
        element.checked = true;
      });
      return lst;
    },



  },

  methods: {
    siguiente() {
      this.polizasVeh.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });

      this.polizasHog.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });

      this.polizasDecesos.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });


      this.polizasMovilidad.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });


      this.polizasNegocio.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });

      this.polizasAccidentes.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });

      this.polizasMascotas.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });

      this.polizasSaludMMT.forEach((element) => {
        if (element.checked == true) {
          this.polizasChecked.push(element.idPoliza);
        }
      });


      // if (this.polizasChecked.length < 1) {
      //   this.errorSeleccion = "Debe seleccionar alguna póliza";
      //   return;
      // }

      this.$store.dispatch("setPolizasSel", this.polizasChecked);
      this.$emit("siguiente");
    },
  },
};
</script>

<style lang="scss" scoped>
.noValido {
  color: red;
  font-weight: bold;
}

.fila {
  margin-bottom: 0.75rem;
  display: flex;
  flex-flow: row nowrap;
}

.cabecera {
  font-size: 120%;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}

.texto {
  font-size: 90%;
  margin-bottom: 1rem;
  color: $azulOscuroMMT;
}

.panel {
  display: flex;
  flex-flow: column nowrap;

  label {
    display: block;
  }

  // input {
  //   width: 100%;
  // }
  button {
    background-color: $colorMMT;
    color: white;
    margin-top: 1rem;
    min-width: 15rem;
  }
}

.contenedor {
  width: 100%;
  max-width: 30rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding: 2rem;
}

.sep {
  height: 0.8rem;
}
</style>
